import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-6 md:py-20 px-4 bg-gray-50 border-y border-gray-200" data-id="element-113">
      <div className="max-w-3xl mx-auto text-center" data-id="element-114">
        <FadeIn data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/1V6GUcQpXwQewkyARYvYmk/ebook_chau_vape_2.jpg" alt="Vendedor en tienda de vape" className="w-full rounded-xl mb-3 md:mb-6" data-id="element-116" />
          <h2 className="font-display font-black text-2xl md:text-4xl text-gray-900 mb-3 md:mb-10" data-id="element-117">
            Te voy a decir algo que{' '}
            <span className="text-red-500" data-id="element-118">nadie te dice:</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-119">
          <div className="space-y-2 md:space-y-6 text-lg md:text-2xl text-gray-700 font-medium leading-relaxed" data-id="element-120">
            <p data-id="element-121">
              Durante 8 años fué dueño de un Vape Shop. Vendí miles de equipos.
              Conocí el vicio desde adentro. Y hoy te digo la verdad: El vapeo
              está diseñado para que no puedas soltarlo. No es falta de
              voluntad, es un sistema atrapando tu cerebro. Yo estuve ahí y sé
              cómo se siente.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}